/**
 * Private-use characters the server wraps around merged values in preview documents, so the preview can
 * highlight each value and link it back to the field it came from. Generated documents never contain them.
 * Keep in sync with LandHawk.Server/LandHawk.Domain/DocumentPreviewMarkers.cs.
 */

/** Inline value: TOKEN_START + token name + NAME_END + value + TOKEN_END. */
export const TOKEN_START = '';
export const NAME_END = '';
export const TOKEN_END = '';

/** Rich-text block (legal description, clauses, acknowledgments): BLOCK_START + name + NAME_END ... BLOCK_END. */
export const BLOCK_START = '';
export const BLOCK_END = '';



// WEBPACK FOOTER //
// ./src/components/common/docxPreview/DocxPreviewMarkers.ts